export const louisianaCountiesList = [
    'Acadia',
    'Allen',
    'Ascension',
    'Assumption',
    'Avoyelles',
    'Beauregard',
    'Bienville',
    'Bossier',
    'Caddo',
    'Calcasieu',
    'Caldwell',
    'Cameron',
    'Catahoula',
    'Claiborne',
    'Concordia',
    'De Soto',
    'East Baton Rouge',
    'East Carroll',
    'East Feliciana',
    'Evangeline',
    'Franklin',
    'Grant',
    'Iberia',
    'Iberville',
    'Jackson',
    'Jefferson',
    'Jefferson Davis',
    'La Salle',
    'Lafayette',
    'Lafourche',
    'Lincoln',
    'Livingston',
    'Madison',
    'Morehouse',
    'Natchitoches',
    'Orleans',
    'Ouachita',
    'Plaquemines',
    'Pointe Coupee',
    'Rapides',
    'Red River',
    'Richland',
    'Sabine',
    'St. Bernard',
    'St. Charles',
    'St. Helena',
    'St. James',
    'St. John The Baptist',
    'St. Landry',
    'St. Martin',
    'St. Mary',
    'St. Tammany',
    'Tangipahoa',
    'Tensas',
    'Terrebonne',
    'Union',
    'Vermilion',
    'Vernon',
    'Washington',
    'Webster',
    'West Baton Rouge',
    'West Carroll',
    'West Feliciana',
    'Winn',
    ]